import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "context-menu" }
const _hoisted_2 = {
  key: 0,
  class: "context-menu__wrapper"
}

import { ref, watch } from 'vue'

// Types
import type { Props } from './index'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'ContextMenu',
  props: {
    trigger: { default: 0 }
  },
  setup(__props: any) {

const props = __props

// Data
const opened = ref<boolean>(false)

// Methods
function toggle(action: boolean | undefined): void {
  opened.value = (typeof action === 'boolean') ? action : !opened.value
}

function tryToClose(): void | boolean {
  if (!opened.value) {
    return false
  }
  toggle(false)
}

// Watch
watch(() => props.trigger, () => {
  toggle(false)
})

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "context-menu__button",
      onClick: toggle
    }, [
      _createVNode(_component_draw_svg, {
        name: "drop-menu-dots",
        width: "20",
        height: "20"
      })
    ]),
    (opened.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, tryToClose]
  ])
}
}

})